import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";
import { BiSearch } from "react-icons/bi";
import axiosConfig from "../Service/axiosConfig"
import { FormParser } from "../Components";
import Modal from 'react-bootstrap/Modal';
import Masters from "../Components/masters.json";
import DataTable from 'react-data-table-component';
import { MdDeleteOutline, MdOutlineEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import useDebouncedValue from "../Utils/Debounce";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
const UserSession = () => {
    const MastersModal = Masters.CustomerManagement
    const [search, SetSearch] = useState({
        search: ""
    })
    const debouncedSearchTerm = useDebouncedValue(search.search, 500);
    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        console.log(name, value)
        SetSearch({ ...search, [name]: value })
    }
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
    const [Error, SetError] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("");
    const [Data, SetData] = useState([]);
    const [loading, setLoading] = useState(false)
    const [RowId, SetRowId] = useState()
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("")
    const [show, setShow] = useState(false);
    const [modalTitle, setModalTitle] = useState("Create User List");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        mobileno: '',
        // role: "customer"
    });
    const handleShow = () => {
        setShow(true)
        // setSelectedImage("")
        setFormData({
            full_name: '',
            email: '',
            mobileno: ''
        });
        setCustomerid(null);
        setModalTitle("Create Customer");
    };
    const handleClose = () => {
        setShow(false)
        // SetError("")
        setpopupType("")
    };
    const handleSort = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`/user_data/sessions/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const formSubmit = (FormData) => {
        console.log(FormData)
        axiosConfig.defaults.headers['Content-Type'] = 'multipart/form-data';
        if (FormData.id) {
            axiosConfig.patch(`/user_data/sessions/${FormData.id}/`, FormData)
                .then(res => {
                    console.log(res)
                    setpopupType("success")
                    GetData();
                    setShow(false);
                }).catch(error => {
                    console.log(error)
                    setpopupType("error")
                })
        } else {
            axiosConfig.post("/user_data/sessions/", FormData).then(res => {
                console.log(res)
                setpopupType("success")
                GetData();
                setShow(false);
            }).catch(error => {
                console.log(error)
                setpopupType(error)
            })
        }
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === "startDate") setStartDate(value);
        if (name === "endDate") setEndDate(value);
    };
    // const GetData = async () => {
    //     setLoading(true)
    //     try {
    //         const responce = await axiosConfig.get(`/user_data/user_list/?page=${currentPage}&page_size=${RowPerPage}`)
    //         console.log(responce)
    //         SetData(responce.data.results)
    //         setLoading(false)
    //         setTotalRows(responce.data.count)
    //     }
    //     catch (error) {
    //         console.log(error)
    //     }

    // }
    const GetData = async () => {
        setLoading(true);
        try {
            let url = `/user_data/sessions/?page=${currentPage}&page_size=${RowPerPage}`;

            // Add date filtering if both dates are selected
            if (startDate && endDate) {
                url += `&start_date=${startDate}&end_date=${endDate}`;
            }

            const response = await axiosConfig.get(url);
            console.log(response);
            SetData(response.data.results);
            setLoading(false);
            setTotalRows(response.data.count);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getSearchResults = async () => {
            axiosConfig.get(`/user_data/sessions/?search=${debouncedSearchTerm}`).then(res => {
                SetData(res.data.results)
            }).catch(error => {
                console.log(error)
            })
        };
        getSearchResults();
    }, [debouncedSearchTerm]);
    useEffect(() => {
        GetData();
    }, [currentPage, RowPerPage, startDate, endDate]);

    const [customerid, setCustomerid] = useState()
    const Customeredit = (id) => {
        console.log(id, 'iddddd')
        axiosConfig.get(`/user_data/sessions/${id}/`).then(res => {
            console.log(res.data)
            setFormData(res.data)
            setCustomerid(id)
            setShow(true)
        }).catch(error => {
            console.log(error)
        })
    }
    // const tableCustomStyles = {
    //     rows: {
    //         style: {
    //         },
    //     },
    //     cells: {
    //         style: {
    //             justifyContent: "center",
    //             // width :"200px"
    //         },
    //     },
    //     headCells: {
    //         style: {
    //             color: "#5C5C5C",
    //             justifyContent: "center",
    //             color: "rgb(33,37,41)",
    //             fontSize: "12px",
    //             fontWeight: 500,
    //             lineHeight: "28px",
    //         },
    //     },
    // };
    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true,
            reorder: true,
        },
        {
            name: "User Name",
            selector: "user_name",
            sortable: true,
            reorder: true,
        },
        {
            name: "User Role",
            selector: "user_role",
            sortable: true,
            reorder: true,
        },
        {
            name: "Device Name",
            selector: "device_name",
            sortable: true,
            reorder: true,
        },
        {
            name: "Platform",
            selector: "platform",
            sortable: true,
            reorder: true,
        },
        {
            name: "Browser Name",
            selector: "browser",
            sortable: true,
            reorder: true,
        },
        {
            name: "OS",
            selector: "os",
            sortable: true,
            reorder: true,
        },
        {
            name: "App Version",
            selector: "app_version",
            sortable: true,
            reorder: true,
        },
        {
            name: "Location",
            selector: "location",
            sortable: true,
            reorder: true,
        },
        {
            name: "IP Address",
            selector: "ip_address",
            sortable: true,
            reorder: true,
        },
        {
            name: "Login Time",
            selector: "login_time",
            sortable: true,
            reorder: true,
        },
        {
            name: "Logout Time",
            selector: "logout_time",
            sortable: true,
            reorder: true,
        },
        {
            name: "Last Activity",
            selector: "last_activity",
            sortable: true,
            reorder: true,
        }
    ]

    return (
        <>
            <div className="child-sidenav">
                <MarketingNavbarComponent />
                <div className="childnav-content">
                    <div className="d-flex align-items-center mt-2">
                        <div className="input-cat-with-icon">
                            <span className="icon-product">
                                <BiSearch />
                            </span>
                            <input
                                type="text"
                                className="input-control"
                                placeholder="Search"
                                name="search"
                                value={search.search}
                                onChange={HandleSearch}
                            />
                        </div>
                    </div>
                    <div className="table-responsive marginTop">
                        <DataTable columns={columns} data={Data} pagination paginationTotalRows={totalRows}
                            paginationPerPage={RowPerPage}
                            paginationDefaultPage={currentPage}
                            onChangePage={(page) => setCurrentPage(page)}
                            paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                            paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                            onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                            onSort={handleSort}
                            paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                            progressComponent={<div className="loader-container">
                                <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                            </div>}
                        />
                    </div>
                    <div>
                        <Modal
                            size="xl"
                            show={show}
                            onHide={handleClose}
                            aria-labelledby="example-modal-sizes-title-lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-modal-sizes-title-lg">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <FormParser modelObject={MastersModal} formData={formData} formSubmit={formSubmit} error={Error} buttonTitle='Save' />
                            </Modal.Body>
                        </Modal>
                        {popupType !== "" &&
                            <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="" />
                        }
                        {deletePopupType !== "" &&
                            <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
                        }
                    </div>

                </div>
            </div>
        </>
    )
}
export { UserSession }